import { memo, useMemo } from 'react'
import Button from 'components/core/Button/Button'
import Icon from 'components/core/Icon/Icon'
import NewsletterSignUpForm from 'components/elements/NewsletterSignUpForm/NewsletterSignUpForm'
import Modal from 'components/interface/Modal/Modal'
import { useModalContext } from 'components/interface/Modal/provider/ModalProvider'

/**
 * The `ModalNewsletter` handles the rendering of
 * the sign up modal
 *
 * @returns {React.ReactElement} the element
 */
function ModalNewsletter () {
  const { onAction } = useModalContext()

  const title = useMemo(() => <h1>Sign up to our Newsletter</h1>, [])
  const options = useMemo(
    () => (
      <>
        <li>
          <Button
            type="symbol"
            icon={'close'}
            size="large"
            color="b"
            onClick={() => onAction('close')}
          />
        </li>
      </>
    ),
    []
  )

  return (
    <Modal.Container size="x-small">
      <Modal.Media size="small">
        <Icon icon="mailer" />
      </Modal.Media>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <NewsletterSignUpForm />
      </Modal.Body>
      <Modal.Footer options={[]}>{options}</Modal.Footer>
    </Modal.Container>
  )
}

// Memoize
export default memo(ModalNewsletter)
